import { createAction, createReducer, createSelector } from '@reduxjs/toolkit';
import { reduxResources } from 'constants/constants';

const initialState = {
  data: null,
  isLoading: true,
  hasError: false,
  total: 0,
  lotDetail: null,
  filter: null,
};

const actions = {
  setLotList: createAction('lot/set-lot'),
  setLoading: createAction('lot/set-loading'),
  setError: createAction('lot/set-error'),
  setSort: createAction('lot/set-sort'),
  setPageSize: createAction('lot/set-page-size'),
  setFilter: createAction('lot/set-filter'),
  setPage: createAction('lot/set-page'),
  fetchLotList: createAction('lot/fetch-lot-list'),
  updateLot: createAction('lot/update-lot'),
  createLot: createAction('lot/create-lot'),
  deleteLotList: createAction('lot/delete-lot-list'),
  fetchLotDetail: createAction('lot/fetch-lot-detail'),
  setLotDetail: createAction('lot/set-lot-detail'),
};

// reducer

const reducer = createReducer(initialState, {
  [actions.setLotList]: (state, action) => {
    const { data, total } = action.payload;
    state.data = data;
    state.total = total;
    state.hasError = false;
    state.isLoading = false;
  },
  [actions.setLoading]: (state, action) => {
    state.isLoading = action.payload;
  },
  [actions.setError]: (state, action) => {
    state.hasError = action.payload;
    state.isLoading = false;
  },
  [actions.setPage]: (state, action) => {
    state.page = action.payload;
  },
  [actions.setPageSize]: (state, action) => {
    state.size = action.payload;
  },
  [actions.setSort]: (state, action) => {
    state.sort = action.payload;
  },
  [actions.setFilter]: (state, action) => {
    state.filter = action.payload;
    if (state.page !== 0) {
      state.page = 0;
    }
  },
  [actions.setLotDetail]: (state, action) => {
    state.lotDetail = action.payload;
  },
});

const selectors = {
  getState: createSelector(
    state => state[reduxResources.LOT],
    state => state,
  ),
  getLotDetail: createSelector(
    state => state[reduxResources.LOT],
    state => state.lotDetail,
  ),
};

// all actions

export { reducer as lotReducer, actions as lotActions, selectors as lotSelectors };
